import { render, staticRenderFns } from "./addLeaveInputs.vue?vue&type=template&id=54f2841e&scoped=true&lang=html"
import script from "./addLeaveInputs.vue?vue&type=script&lang=js"
export * from "./addLeaveInputs.vue?vue&type=script&lang=js"
import style0 from "./addLeaveInputs.vue?vue&type=style&index=0&id=54f2841e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f2841e",
  null
  
)

export default component.exports